import courseArrangePopup from './course-arrange/popup';
import visualTimetablePopup from './visual-timetable/popup';
import studentPopup from './student-management/popup';
import classPopup from './class-management/popup';

export default [...courseArrangePopup, ...visualTimetablePopup, ...studentPopup, ...classPopup];
